module.exports = __webpack_public_path__ + "img/send.576dd87d.svg";